function filterProductsByActiveTab() {
  const activeButton = document.querySelector(".product-tab-category__filter.active");
  const selectedFilter = activeButton?.getAttribute("data-filter");
  const productCards = document.querySelectorAll(".product-tab-category__product");

  productCards.forEach((card) => {
    const filters = JSON.parse(card.getAttribute("data-filters") || "[]");
    const shouldShow = selectedFilter === "all" || filters.includes(selectedFilter);
    card.style.display = shouldShow ? "flex" : "none";
  });
}

function setTabFromQuery() {
  const urlParams = new URLSearchParams(window.location.search);
  const tabFromURL = urlParams.get("tab");
  if (tabFromURL) {
    const tabButtons = document.querySelectorAll(".product-tab-category__filter");
    let found = false;
    tabButtons.forEach((button) => {
      const filter = button.getAttribute("data-filter");
      if (filter === tabFromURL) {
        tabButtons.forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");
        found = true;
      }
    });
    if (found) filterProductsByActiveTab();
  }
}

function setupTabButtonListeners() {
  const tabButtons = document.querySelectorAll(".product-tab-category__filter");
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");
      filterProductsByActiveTab();

      const selectedFilter = button.getAttribute("data-filter");
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("tab", selectedFilter);
      window.history.replaceState({}, "", newUrl);
    });
  });
}

function setupCardAnimations() {
  const productCards = document.querySelectorAll(".product-tab-category__wrapper .product-tab-category__product");
  const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  productCards.forEach(card => {
    const img = card.querySelector("img.image_with_video");
    const video = card.querySelector("video");
    if (!img || !video) return;

    // video.preload = "auto";
    video.loop = false;
    video.muted = true;
    video.playsInline = true;

    card.addEventListener("mouseenter", () => {
      img.style.opacity = "0";
      video.play();
    });

    video.addEventListener("ended", () => {
      img.style.opacity = "1";
    });

    if (isTouch) {
      card.addEventListener("click", function (evt) {
        if (card.classList.contains("product-tab-category__product-submit-form")) {
          return;
        }

        if (evt.target.closest('form')) {
          return;
        }

        const cardEl = card;

        if (cardEl.dataset.clicked === "false") {
          evt.preventDefault();
          img.style.opacity = "0";
          video.currentTime = 0.15;
          video.play();
          cardEl.dataset.clicked = "true";
        } else {
          cardEl.querySelector('.product-tab-category__product__link').click();
        }
      });
    }
  });
}


function setupSubmitFormCards() {
  const submitCards = document.querySelectorAll(".product-tab-category__product-submit-form");

  submitCards.forEach(card => {
    const form = card.querySelector(".bf-form-submit");
    if (!form) return;

    const links = card.querySelectorAll("a");
    links.forEach(link => {
      link.addEventListener("click", (evt) => {
        evt.preventDefault();
      });
    });

    card.addEventListener("click", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  });
}

let swiper = null;
function initMobileSwiper() {
  if (swiper) return;
  const configSlider = document.querySelector('.swiper-filters').dataset.elements;
  let defaultItems = (configSlider === 'false') ? 1 : 1.3;
  let defaultLoop = (configSlider === 'false') ? false : true;

  swiper = new Swiper('.swiper-filters', {
    slidesPerView: defaultItems,
    loop: defaultLoop,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const tabFromURL = urlParams.get("tab");
  swiper.slides.forEach(function (slide, idx) {
    if (slide.dataset.filter === tabFromURL) {
      let getOrderValueFromCSS = window.getComputedStyle(slide);
      let currentOrder = +getOrderValueFromCSS.getPropertyValue('order');
      let index = (currentOrder === 0) ? idx : currentOrder;
      swiper.slideTo(index);
    }
  });

  swiper.on('slideChange', function () {
    const activeSlide = swiper.slides[swiper.activeIndex];
    swiper.slides.forEach(function (slide, idx) {
      if (activeSlide === slide) {
        let getOrderValueFromCSS = window.getComputedStyle(slide);
        let currentOrder = +getOrderValueFromCSS.getPropertyValue('order');
        let index = (currentOrder === 0) ? swiper.activeIndex : currentOrder;
        console.log({
          fakeIndex: currentOrder,
          realIndex: swiper.activeIndex
        });
        swiper.slides[index].click();
      }
    });
    if (activeSlide) {
      activeSlide.click();
    }
  });
}

function destroyMobileSwiper() {
  if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  }
}

function handleResizeSwiper() {
  if (window.innerWidth <= 767) {
    initMobileSwiper();
  } else {
    destroyMobileSwiper();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setupTabButtonListeners();
  setTabFromQuery();
  filterProductsByActiveTab();

  setupCardAnimations();
  setupSubmitFormCards();

  handleResizeSwiper();
});

window.addEventListener('resize', function () {
  clearTimeout(window._swiperResizeTimeout);
  window._swiperResizeTimeout = setTimeout(handleResizeSwiper, 150);
});
